import { Text, Toast } from '@loomhq/lens';
import pluralize from 'pluralize';
import React, { ReactElement, useCallback } from 'react';

import { NotifiedUsersType, useClipsState } from './clips/state';

const formatName = ({ first_name, last_name }) => {
  const firstName = first_name || '';
  const lastName = last_name || '';

  return `${firstName} ${lastName}`.trim();
};

const SavedClipText = ({
  notifiedUsers = [],
}: {
  notifiedUsers: NotifiedUsersType[];
}) => {
  const baseText = 'Your changes were saved';

  if (!notifiedUsers || !notifiedUsers.length) {
    return <Text>{baseText}</Text>;
  }

  const formattedNames = notifiedUsers.map(userData => {
    return formatName(userData);
  });

  if (notifiedUsers.length <= 3) {
    return (
      <Text>
        {baseText}
        {`, and we notified `}
        <strong>
          {formattedNames.reduce((acc, curr) => {
            return `${acc}${curr}, `;
          }, '')}
        </strong>
        {` that you added their clips to your Loom`}
      </Text>
    );
  }

  const visibleNames = [formattedNames[0], formattedNames[1]];
  const remainingCount = formattedNames.length - 2;

  return (
    <Text>
      {baseText}
      {`, and we notified `}
      <strong>
        {visibleNames.reduce((acc, curr) => {
          return `${acc}${curr}, `;
        }, '')}
      </strong>
      {` and `}
      <strong>
        {remainingCount} {pluralize('others', remainingCount)}
      </strong>
      {` that you added their clips to your Loom`}
    </Text>
  );
};

const WeaveToast = (): ReactElement => {
  const { showWeaveToast, setShowWeaveToast, setNotifiedUsers, notifiedUsers } =
    useClipsState(state => ({
      setShowWeaveToast: state.setShowWeaveToast,
      showWeaveToast: state.showWeaveToast,
      notifiedUsers: state.notifiedUsers,
      setNotifiedUsers: state.setNotifiedUsers,
    }));

  const hideClipSavedToast = useCallback(() => {
    setShowWeaveToast(false);
    setNotifiedUsers([]);
  }, [setShowWeaveToast, setNotifiedUsers]);

  return (
    <Toast isOpen={showWeaveToast} onCloseClick={hideClipSavedToast}>
      <SavedClipText notifiedUsers={notifiedUsers} />
    </Toast>
  );
};

export default WeaveToast;
